import React from 'react';

import { Box, Text as UCLText } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { IOffer } from '@rbi-ctg/menu';
import Link from 'components/link';
import { OfferCell } from 'components/offer/ui-refresh/cell';
import { ClearSelectedOffer } from 'state/offers/hooks/types';

import { BG, BTN_FONT, BTN_FONT_WEIGHT, BTN_TEXT_DECORATION, COLOR, FONT } from './constants';

interface IOfferSelectedProps {
  offer: IOffer;
  onRemoveSelectedOffer: ClearSelectedOffer;
  onPress: (offerId: string) => void;
  isSelected: boolean;
}

const Container = Box.withConfig({
  backgroundColor: BG,
  padding: '5px',
});
const OfferSelectedHeader = Box.withConfig({
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingX: '$6',
  paddingY: 0,
});
const Text = UCLText.withConfig({
  fontSize: 'sm',
  lineHeight: '2xs',
  color: COLOR,
  fontFamily: FONT,
});
const RemoveButton = Link.withConfig({
  fontFamily: BTN_FONT,
  color: COLOR,
  lineHeight: 'md',
  fontWeight: BTN_FONT_WEIGHT,
  isUnderlined: true,
  textDecoration: BTN_TEXT_DECORATION,
});

const OfferSelected: React.FC<React.PropsWithChildren<IOfferSelectedProps>> = ({
  offer,
  onRemoveSelectedOffer,
  isSelected,
  onPress,
}) => {
  const { formatMessage } = useIntl();
  const removeOffer = () => {
    onRemoveSelectedOffer();
  };
  return (
    <Container testID="offer-selected-container">
      <OfferSelectedHeader>
        <Text>{formatMessage({ id: 'offerSelected' })}</Text>
        <RemoveButton testID="offer-selected-remove-btn" onPress={removeOffer}>
          {formatMessage({ id: 'remove' })}
        </RemoveButton>
      </OfferSelectedHeader>
      <OfferCell offer={offer} isSelected={isSelected} offerFeedback={null} onPress={onPress} />
    </Container>
  );
};

export default OfferSelected;
